
import { useState } from "react";
import Select from 'react-select'

export const OfficerNameCommanDDL = () => {

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsZoneName = [
        { id: 1, value: 'Demo1', label: 'Demo1' },
        { id: 2, value: 'Demo2', label: 'Demo2' },
    ]

    return (
        <>
           
            <Select
                id='ZoneNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: ZoneNameID.ID, label: ZoneNameID.Label }}
                onChange={(e) => {
                    e ?
                        setZoneNameID({ ...ZoneNameID, ID: e.value, Label: e.label })
                        :
                        setZoneNameID({ ...ZoneNameID, ID: 0, Label: "Select..." })

                }}
                options={optionsZoneName}
            />
        </>
    )
}